define.alias("shared/components/shared/publish/switcher/index", "settings/components/shared/publish/switcher/index");